import * as React from 'react';
import { connect } from 'react-redux';
import {GlobalState} from "../reduxSetting";
import {RouteComponentProps} from "react-router";


namespace Footer {
    export interface Props extends RouteComponentProps<void> {
        version: string;
    }
    export interface State {

    }
}

function mapStateToProps(state: GlobalState): any {
  return {
      version: ""
  };
}

function mapDispatchToProps(dispatch) {
    return {};
}

class Footer extends React.Component<Footer.Props, Footer.State> {
    render() {
        return <footer> {this.props.version} </footer>;
    }
}

const FooterRedux = connect(mapStateToProps, mapDispatchToProps)(Footer);
export { FooterRedux as Footer};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Footer.tsx